import { render, staticRenderFns } from "./MainSidebarIdeaDetails.vue?vue&type=template&id=9c0b73c8&scoped=true"
import script from "./MainSidebarIdeaDetails.vue?vue&type=script&lang=js"
export * from "./MainSidebarIdeaDetails.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarIdeaDetails.vue?vue&type=style&index=0&id=9c0b73c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0b73c8",
  null
  
)

export default component.exports